import React from "react";
import "./Hero.css";

const Hero = () => {
  return (
    <section className="hero" id="hero">
      <a href="#projects" className="hero-explore-hint">
        <span className="hero-explore-arrow">↓</span>
        <span className="hero-explore-text">PROJELERİMİZ</span>
      </a>
    </section>
  );
};

export default Hero;